export default __webpack_public_path__ + "static/media/game.7d3a8646.jpg";